import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  key: 1,
  class: "impersonation-bar"
};
const _hoisted_3 = {
  class: "impersonation-bar__inner"
};
const _hoisted_4 = {
  class: "impersonation-bar__text"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = ["title", "aria-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.isImpersonating && !$options.barVisible ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    type: "button",
    class: "impersonation-pill",
    title: $options.text,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.restore && $options.restore(...args))
  }, [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
    class: "bx bx-user-check"
  }, null, -1)]))], 8, _hoisted_1)) : _createCommentVNode("", true), $options.barVisible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("i", {
    class: "bx bx-user-check me-2"
  }, null, -1)), _createElementVNode("span", _hoisted_4, _toDisplayString($options.text), 1), _createElementVNode("button", {
    type: "button",
    class: "btn btn-sm btn-light ms-3",
    disabled: _ctx.leavingImpersonation,
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.leaveImpersonation && _ctx.leaveImpersonation(...args))
  }, [_cache[4] || (_cache[4] = _createElementVNode("i", {
    class: "bx bx-log-out-circle me-1"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t('users.impersonation.back').ucFirst()), 1)], 8, _hoisted_5), _createElementVNode("button", {
    type: "button",
    class: "btn btn-sm btn-link impersonation-bar__close",
    title: _ctx.$t('users.impersonation.dismiss'),
    "aria-label": _ctx.$t('users.impersonation.dismiss'),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.dismiss && $options.dismiss(...args))
  }, [...(_cache[5] || (_cache[5] = [_createElementVNode("i", {
    class: "bx bx-x"
  }, null, -1)]))], 8, _hoisted_6)])])) : _createCommentVNode("", true)], 64);
}